import React from "react";
import { InputProps } from "react-select";

const HeaderSearchInput: React.FC<InputProps> = ({ children, ...props }) => {
  return <input {...props} className="search-menu-input" />;
};

export default HeaderSearchInput;
